import { ContainerHtml } from "@dinahmoe/dmafjs-visual";
import { bridge } from "@dinahmoe/dmafjs-core";

class SearchContainerEnvironment extends ContainerHtml {
  setProps(eNode) {
    super.setProps(eNode);

    let lastValue = null;
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          const scrollValue = eNode.props["scrollValue"] || 0;
          const rect = eNode.element.getBoundingClientRect();
          const absoluteY = Math.round(scrollValue + rect.top - 250);
          if (lastValue === null || Math.abs(absoluteY - lastValue) > 50) {
            lastValue = absoluteY;
            bridge.update({
              uid: eNode.uid,
              key: "absolute_position",
              value: absoluteY,
              sender: "browser"
            });
          }
        }
      }
    }, { threshold: [0, 0.5, 1] });
    observer.observe(eNode.element);
  }
}

const searchContainerEnvironment = new SearchContainerEnvironment("se26:searchContainer");

export { SearchContainerEnvironment, searchContainerEnvironment };
